export default [
    {
        path: '',
        name: 'pageContactUsRouter',
        component: () => import('./page-contact-us')
    }
]